export function getItemEndDate(item) {
  if (!item?.endDate) {
    return null;
  }

  if (typeof item.endDate.toDate === "function") {
    return item.endDate.toDate();
  }

  return new Date(item.endDate);
}

export function isItemActive(item, now = new Date()) {
  const endDate = getItemEndDate(item);
  return Boolean(endDate) && endDate > now;
}

export function sortItemsByEndDate(items) {
  return [...items].sort((a, b) => {
    const endDateA = getItemEndDate(a);
    const endDateB = getItemEndDate(b);

    if (!endDateA && !endDateB) return 0;
    if (!endDateA) return 1;
    if (!endDateB) return -1;

    return endDateA - endDateB;
  });
}
